import { useSelector } from "react-redux";

import type { TypedUseSelectorHook } from "react-redux";

import type { AppState } from "../../model/reducers";

/** `useSelector` pre-bound to the app's `RootState`. */
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export default useAppSelector;
